import { Box } from "@mui/material";
import WebViewer from '@pdftron/webviewer';
import React, { useContext, useEffect, useRef } from "react";
import PdfViewerContext from "./PdfViewerContext";
import { useMsal } from "@azure/msal-react";
import './PdfViewer.css';
import { useDispatch, useSelector } from "react-redux";
import { selectAll } from "../../features/signature/inbox/inboxSlice";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { getCurrentUser, recipientStatus, getDateFormat, clientTenant, isValid } from "../../constants/constants";
import { validUser } from "../../app/reducer/userSlice";

function disabledToolButton(iframeDoc, document) {
   //Disable toolbargroup menuitems
   let toolbarMenuItem = iframeDoc.querySelectorAll('.Dropdown__items button.Dropdown__item');
   let toolbarMenuItem2 = iframeDoc.querySelectorAll('button.ribbon-group');
   let commentsBtn = iframeDoc.querySelectorAll('[data-element="toggleNotesButton"],[data-element="searchButton"],[data-element="selectToolButton"],[data-element="outlinesPanelButton"]');

   if (document) {
      for (let btn of commentsBtn) {
         btn.classList.add('disabled');
         btn.setAttribute('disabled', true);
      }
      iframeDoc.querySelector('[data-element="panToolButton"]').click();
   }

   toolbarMenuFun(toolbarMenuItem);
   toolbarMenuFun(toolbarMenuItem2);

   function toolbarMenuFun(item) {
      let pickedText = iframeDoc.querySelector('.picked-option-text')
      for (let i = 0; i < item.length; i++) {
         if (i < 5 || i == 6) {
            item[i].removeAttribute('data-element');
            item[i].setAttribute('disabled', true);
            item[i].setAttribute('style', `cursor: not-allowed; opacity: 0.5;`)
            item[i].classList.remove('active')
         }
         if (document) {
            item[i].removeAttribute('data-element');
            item[i].setAttribute('disabled', true);
            item[i].setAttribute('style', `cursor: not-allowed; opacity: 0.5;`)
         }
         if (i == 5) {
            item[i].classList.add('active');
            pickedText.innerHTML = item[i].innerHTML
         }
      }
   }

}

const PdfViewer = ({ setDisableSubmit, secureWidgetAnnotations = true }) => {
   const { id: envId } = useParams();
   const dispatch = useDispatch();
   const valid = useSelector(state => state.user.valid);
   const envelopes = useSelector(selectAll);
   const envelope = useSelector((state) => state?.envelope?.entity?.recipients);
   const documentStatus = recipientStatus(envelopes, envId);
   const [signedDocument, setSignedDocument] = useState(null);
   const [callBack, setCallBack] = useState(false);
   const msalInstance = useMsal().instance;
   const { tenantId } = msalInstance?.config?.auth;
   const isValidTenant = isValid((tenantId.match('engen')?.[0] || tenantId), clientTenant)
   console.log("🚀 ~ isValidTenant:", isValidTenant)
   const { idTokenClaims: { emails }, localAccountId, name } = msalInstance.getActiveAccount();
   const activeUserEmailId = (Array.isArray(emails) ? emails[0] : emails).toLowerCase() || '';
   const { setInstance, setAnnotManager, instance } = useContext(PdfViewerContext);
   const viewer = useRef(null);
    const docViewerLoad = useRef(false);
    const  CurrentTenantId  = msalInstance?.config?.auth;

   useEffect(() => {
      setSignedDocument(documentStatus || valid);
   }, [envelopes, valid]);

   useEffect(() => {
      if (!instance || !callBack) return;

      const { annotationManager } = instance.Core;

      const widgetAnnots = annotationManager.getAnnotationsList().filter(annot => annot.fieldName?.split('_')[0].toLowerCase() === activeUserEmailId);

      const hasIncompleteFields = widgetAnnots.some(annot => {
         const value = annot?.getValue?.() || '';
         const hasCustomAppearance = typeof annot?.CA === 'object';
         const isSigned = value.length > 0 || hasCustomAppearance;
         return !isSigned;
      });

      setDisableSubmit(hasIncompleteFields);
      setCallBack(false);
   }, [callBack]);

   useEffect(() => {
      dispatch(validUser());
      if (!docViewerLoad.current) {
          docViewerLoad.current = true;
          debugger;
         WebViewer(
            {
                 licenseKey: 'The Most Group Inc dba Simplify Healthcare Technology:OEM:CollaborateTM::B+:AMS(20271019):57A5A9DD04C7380AC360B03AC9A2527860611F859F78ED13DD9F7BFACF525037128A31F5C7',
               fullAPI: true,
               path: '/webviewer',
               annotationUser: localAccountId,
            },
            viewer.current,
         ).then(async instance => {
            const { annotationManager, documentViewer } = instance.Core;
            const { UI, Feature, annotManager, Annotations } = instance;
            const signatureTool = documentViewer.getTool('AnnotationCreateSignature');

            // Set instance in context to make it available to all context consumers
            setInstance(instance);
            setAnnotManager(annotManager);

            if (signedDocument) return;

            const defaultMouseLeftUp = signatureTool.mouseLeftUp;
            signatureTool.mouseLeftUp = function (e, widget) {
               // ignore "mouseLeftUp" event when no widget is selected
               if (!widget) return;
               defaultMouseLeftUp.apply(this, arguments);
            }

            // Default web viewer settings
            UI.setFitMode(instance.FitMode.FitWidth);
            UI.enableFeatures([UI.Feature.Initials]);

            // Show loader
            UI.openElements(['loadingModal']);
            UI.disableFeatures([Feature.ThumbnailMerging, Feature.ThumbnailReordering]);
            UI.disableElements(['rubberStampToolGroupButton', 'toggleCompareModeButton', 'signaturePanel', 'signaturePanelButton']);

            // Set authors map
            annotationManager.setAnnotationDisplayAuthorMap((userId) => {
               // TODO: Add switch-case with id-name for all recipients on given envelope
               return name;
            })

            // Register all event listeners
            documentViewer.addEventListener('documentLoaded', () => {
               UI.closeElements(['loadingModal']);
            });

            documentViewer.addEventListener('annotationsLoaded', () => {
               const signatureWidgetAnnots = annotationManager.getAnnotationsList().filter(annot => annot instanceof Annotations.SignatureWidgetAnnotation);
               signatureWidgetAnnots.forEach(annot => {
                  annot.isSignedDigitally().then(isSigned => {
                     if (isSigned) {
                        console.log(annot.fieldName, "Is signed");
                     } else {
                        console.log(annot.fieldName, "Not signed");
                     }
                  })
               });
            });

            function normalStyles(widget) {
               const isActiveUser = getCurrentUser(envelope, activeUserEmailId, widget);
               if (isValidTenant) {
                  setCallBack(true);
               }
               if (widget instanceof Annotations.SignatureWidgetAnnotation) {
                  return {
                     border: null,
                     'font-size': '100%',
                     cursor: isActiveUser ? '' : 'not-allowed'
                  }
               }
               if (widget instanceof Annotations.WidgetAnnotation) {
                  return {
                     border: 'none',
                     'font-size': '15pt',
                     cursor: isActiveUser ? '' : 'not-allowed'
                  }
               }
            };

            const fieldManager = annotationManager.getFieldManager();

            // Update date field logic
            function updateDateField(textWidgetAnnots, action) {
               const isAction = action == 'delete';
               const currentDate = isAction ? '' : getDateFormat(new Date());

               textWidgetAnnots.forEach(dateAnnot => {
                  const field = fieldManager.getField(dateAnnot.fieldName);
                  if (getCurrentUser(envelope, activeUserEmailId, dateAnnot, 'date')) {
                     if (field) {
                        field.setValue(currentDate, dateAnnot.PageNumber);
                        dateAnnot.setValue(currentDate);
                        dateAnnot.fieldFlags.set('ReadOnly', !isAction);

                        annotationManager.redrawAnnotation(dateAnnot);

                        annotationManager.trigger('fieldChanged', [field, dateAnnot]);
                     }
                  }
               });
            }

            annotManager.on('annotationChanged', (annotations, action, { imported }) => {
               const signatureWidgetAnnots = annotationManager.getAnnotationsList().filter(annot => annot instanceof Annotations.SignatureWidgetAnnotation);
               const textWidgetAnnots = annotationManager.getAnnotationsList().filter(annot => annot instanceof Annotations.TextWidgetAnnotation);
               if (imported && action === 'add') {
                  annotations.forEach(function (annot) {
                     if (annot instanceof Annotations.WidgetAnnotation || annot instanceof Annotations.SignatureWidgetAnnotation) {
                        if (annot instanceof Annotations.CheckButtonWidgetAnnotation === false) {
                            annot.Width = 150;
                            if (CurrentTenantId && CurrentTenantId.tenantId) {
                                annot.Width = CurrentTenantId.tenantId === "hcok" ? 100 : 150;
                            }
                           annot.Height = 15;
                           annotationManager.redrawAnnotation(annot);
                        }
                     }
                     Annotations.WidgetAnnotation.getCustomStyles = normalStyles;
                     if (annot instanceof Annotations.WidgetAnnotation) {
                        if (getCurrentUser(envelope, activeUserEmailId, annot)) {
                           if (textWidgetAnnots && secureWidgetAnnotations) {
                              annot.fieldFlags.set('ReadOnly', false);
                           }
                        }
                        else {
                           if (textWidgetAnnots || secureWidgetAnnotations) {
                              annot.fieldFlags.set('ReadOnly', true);
                           }
                        }
                     }
                  })
               }

               if (action === 'add') {
                  signatureWidgetAnnots.forEach(annot => {
                     if (getCurrentUser(envelope, activeUserEmailId, annot)) {
                        if (annot.CA !== null && Object.keys(annot?.CA)?.length > 0) {
                           if (isValidTenant) {
                              setCallBack(true);
                              updateDateField(textWidgetAnnots);
                              return
                           }
                           setDisableSubmit(false);
                        }
                     }
                  })
               }
               else if (action === 'delete') {
                  signatureWidgetAnnots.forEach(annot => {
                     if (getCurrentUser(envelope, activeUserEmailId, annot)) {
                        if (!'CA'.includes(Object.keys(annot?.CA))) {
                           if (isValidTenant) {
                              updateDateField(textWidgetAnnots, 'delete');
                              setCallBack(true);
                              return
                           }
                           setDisableSubmit(true);
                        }
                     }
                  });
               }
            });

            annotationManager.addEventListener('fieldChanged', (field, value) => {
               if (field.type === 'Sig') {
                  console.log('~Signature field changed:', field.name);
                  console.log('~Signature value (appearance):', value);
               }
               //console.log("🚀 ~ fieldChanged:", field, value);
            });
         });
      }
   }, []);

   useEffect(() => {
      if (!instance) return;
      if (signedDocument) {
         const { PDFNet, annotationManager, documentViewer } = instance?.Core;
         const { UI, Feature } = instance;
         const iframeDoc = UI.iframeWindow.document;

         //Document Signed features button disabled
         documentViewer.addEventListener('documentLoaded', () => {
            console.log("~Document loaded!!!");
            instance.hotkeys.off();
            instance.disableElements(['contextMenuPopup']);
            UI.disableElements(['toolsHeader', 'thumbnailControl', 'thumbMultiSelect', 'documentControl', 'annotationPopup', 'selectToolButton']);
            UI.disableFeatures([Feature.ThumbnailMultiselect, Feature.PageNavigation]);
            disabledToolButton(iframeDoc, document);

            (async () => {
               await PDFNet?.initialize();
               const doc = await documentViewer?.getDocument()?.getPDFDoc();
               // export annotations from the document
               const annots = await annotationManager?.exportAnnotations();

               // Run PDFNet methods with memory management
               await PDFNet.runWithCleanup(async () => {

                  // lock the document before a write operation
                  // runWithCleanup will auto unlock when complete
                  doc.lock();

                  // import annotations to PDFNet
                  const fdf_doc = await PDFNet?.FDFDoc.createFromXFDF(annots);
                  await doc.fdfUpdate(fdf_doc);

                  // flatten all annotations in the document
                  await doc.flattenAnnotations();

                  // or optionally only flatten forms
                  // await doc.flattenAnnotations(true);

                  // clear the original annotations
                  annotationManager.deleteAnnotations(annotationManager.getAnnotationsList(), { force: true });

                  // optionally only clear widget annotations if forms were only flattened
                  // const widgetAnnots = annots.filter(a => a instanceof Annotations.WidgetAnnotation);
                  // annotationManager.deleteAnnotations(widgetAnnots);
               });

               // clear the cache (rendered) data with the newly updated document
               documentViewer.refreshAll();

               // Update viewer to render with the new document
               documentViewer.updateView();

               // Refresh searchable and selectable text data with the new document
               documentViewer.getDocument().refreshTextData();
            })()
         })

      }
      return () => false
   }, [instance, signedDocument])

   return (
      <Box className='pdf-viewer' mt={2}>
         <Box className="webviewer" ref={viewer} style={{ height: 'calc(100vh - 170px)' }}></Box>
      </Box>
   );
};

export default PdfViewer;